export default __webpack_public_path__ + "static/media/rodna.4cdef556.jpg";